"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMountedRef = useMountedRef;

var _react = require("react");

function useMountedRef() {
  var mountedRef = (0, _react.useRef)(false); // Basically the same as "useDidMount" because it has no dependencies

  (0, _react.useEffect)(function () {
    mountedRef.current = true;
    return function () {
      // The cleanup function of useEffect is called by React on unmount
      mountedRef.current = false;
    };
  }, []);
  return mountedRef;
}